//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { store } from "@/observable/store";
import { inspectOrder } from "../../model/trader/orderService";
import userInfoToast from "@/components/toast/userInfo";
import { FactoryUtils } from "@/utils/FactoryUtils";
import Txrweb from "@/utils/mixin/mixinTxrweb";

export default {
  name: "quota",
  mixins: [Txrweb],
  data() {
    return {
      uuid: "",
      statusFlag: true,
      timer: null,
      text: {},
      code: "--",
      isPayFlag: "",
      payText: "支付成功",
      timeDelayer: null,
    };
  },

  computed: {
    refid() {
      return store.refid;
    },
  },
  components: {
    userInfoToast,
  },
  created() {
    console.log("**************支付成功页面created回调触发***************");
    console.log("路由参数")
    console.log(this.$route.query)
    console.log("路由参数")
    console.log("保存URL参数中的bizKey和version")
    this.querySetTX();
    this.isPayFlag = this.$route.query.isPayFlag || "1";

    if (this.isPayFlag == "1") {
      this.payText = "支付成功";
    }
    if (this.isPayFlag == "2") {
      this.payText = "开通成功";
      this.STATISTICS("load", "sybao_ins_renewed_page");
    }
    if (this.isPayFlag == "4") {
      this.payText = "操作成功";
      this.STATISTICS("load", "sybao_ins_operation_success_page");
    }

    let uuid = this.$route.query.uuid;
    if (Array.isArray(uuid)) {
      this.uuid = uuid[0];
    } else {
      this.uuid = uuid;
    }

    this.getText();
    
  },
  mounted() {
    document.title = this.payText;
    
    console.log("调用支付成功页的录制初始化")
    if(this.templateFlag != 'coupon'){ //coupon为卡券购买 不需要录入视频
      this.finishTX()
    }

    if (this.templateFlag != "tk_mil") {
      this.getState();
    } else {
      this.statusFlag = false;
      if (this.isPayFlag == "1") {
        //支付成功
        this.STATISTICS_CONFIG.insur_pay_success_page()
        // this.finishTX();
        if (this.stopTX) {
          /** 加2s延迟，防止前面的初始化未成功 */
          setTimeout(() => {
            this.stopTX()
          }, 3000)
        }
      }
    }
  },
  beforeDestroy() {
    window.clearInterval(this.timer);
    this.timer = null;
    if (this.checkPayAndInsuranceStatusTimer) {
      window.clearTimeout(this.checkPayAndInsuranceStatusTimer)
    }
    /** 离开组件时，强制结束录制 */
    // if (this.stopTX) {
    //   this.stopTX()
    // }
  },
  computed: {
    channal_id() {
      return this.CHANNAL_ID;
    },
    c_type() {
      return this.$route.query.c_type || "tmpl";
    },
    templateFlag() {
      return this.$route.query.templateFlag || "";
    },
    outTrade() {
      return this.$route.query.outTrade || "";
    },
  },
  methods: {
    getText() {
      FactoryUtils.paySuccess().then((res) => {
        if (this.templateFlag == "coupon") {
          //卡券
          this.text = res.Card;
        } else {
          this.text = res.insurance;
        }
      });
    },
    getState() {
      //console.log('uuid',this.uuid)
      this.timeDelayer = setTimeout(() => {
        this.$router.replace({
          path: "/payResult",
          query: this.$route.query,
        });
      }, 10000);
      let number = this.uuid || this.outTrade;
      this.timer = setInterval(() => {
        inspectOrder(this.templateFlag, number)
          .then((data) => {
            if (data.is_paid != 0) {
              //是否支付
              this.statusFlag = false;
              window.clearInterval(this.timer);
              window.clearTimeout(this.timeDelayer);
              this.timer = null;
              this.timeDelayer = null;
              this.code = data.code;
              if (this.isPayFlag == "1") {
                //支付成功
                this.STATISTICS_CONFIG.insur_pay_success_page()
                // this.finishTX();
                this.$nextTick(()=>{
                  if (this.stopTX) {
                    this.stopTX()
                  }
                })
              }
            }
          })
          .catch((err) => {
            window.clearInterval(this.timer);
            window.clearTimeout(this.timeDelayer);

            if (err.code == "50") {
              if (this.CHANNAL_ID == "APP") {
                window.location.href =
                  process.env.VUE_APP_HREF +
                  encodeURIComponent(`${window.location.origin}/personal`);
              } else {
                this.STATISTICS("load", "sybao_ins_renewed_page");
                this.$refs.showLogin.showoast();
              }
            }
          });
      }, 1000);
    },
    payClick() {
      //console.log('我是跳转保单')
      if (this.templateFlag == "coupon") {
        //卡券
        this.STATISTICS("click", "sybao_ins_paysuc_detail_click");
        this.$router.replace({
          path: "/coupon",
          query: {
            sjc: Date.parse(new Date()),
            flag: "postdisable",
          },
        });
      } else {
        //保险
        if (this.isPayFlag == "1") {
          this.payText = "支付成功";
          this.STATISTICS("click", "sybao_ins_paysuc_detail_click");
        } else if (this.isPayFlag == "2") {
          this.payText = "开通成功";
          this.STATISTICS("click", "sybao_ins_renewed_detail_click");
        } else {
          this.STATISTICS("click", "sybao_ins_paysuc_detail_click");
        }
        // console.log('我是uuid',this.uuid,this.templateFlag)
        this.$router.replace({
          path: "/orderDetail",
          query: {
            sjc: Date.parse(new Date()),
            uuid: this.uuid,
            templateFlag: this.templateFlag,
            flag: "postdisable",
          },
        });
      }
    },
    copy() {
      this.STATISTICS("click", "sybao_ins_paysuc_copy_click");
    },
    //复制成功
    onCopy(e) {
      //console.log(e);
      this.$toast("复制成功");
    },
    //复制失败
    onError(e) {
      this.$toast("复制失败");
    },
  },
};
